enum CountriesActionsEnum {
    CountriesGet = 'COUNTRIES/GET',
    CountriesSet = 'COUNTRIES/SET',
}

export default CountriesActionsEnum;
